<template>
    <div>
        <div class="mb-4">
            <h5>{{ $t(`평가신청 기업 정보`) }}</h5>
            <!--      lg 이상의 화면의 경우          -->
            <b-table-simple bordered class="d-none d-lg-table bgray-100" fixed>
                <b-tbody>
                    <template>
                        <b-tr>
                            <b-td>
                                <p class="f-90 gray-600 fw-400 mb-1">{{
                                        $t(`업체코드`)
                                    }}</p>
                                <div>
                                    <h6 class="gray-700 text-black fw-500 f-110 mb-0">
                                        {{
                                            selected_vendor.vendor_code || '  -  '
                                        }}</h6>
                                </div>
                            </b-td>
                            <b-td>
                                <p class="f-90 gray-600 fw-400 mb-1">{{
                                        $t(`기업명 및 소재지`)
                                    }}</p>
                                <div>
                                    <h6 v-show="$i18n.locale === 'ko'"
                                        class="gray-700 text-black fw-500 f-110 mb-0">
                                        {{ selected_vendor.company.company_name_dip }} /
                                        {{ selected_vendor.company.country_en }}</h6>
                                    <h6 v-show="$i18n.locale !== 'ko'"
                                        class="gray-700 text-black fw-500 f-110 mb-0">
                                        {{
                                            selected_vendor.company.company_name_en_dip
                                        }} / {{
                                            selected_vendor.company.country_en
                                        }}</h6>
                                </div>
                            </b-td>
                            <b-td v-if="tenant_register">
                                <p class="f-90 gray-600 fw-400 mb-1">
                                    {{ $t(`원청사`) }}</p>
                                <div>
                                    <h6 class="gray-700 text-black fw-500 f-110 mb-0">
                                        {{
                                            selected_vendor.hd_corporate || '  -  '
                                        }}</h6>
                                </div>
                            </b-td>
                        </b-tr>
                        <b-tr>
                            <b-td>
                                <p class="f-90 gray-600 fw-400 mb-1">{{
                                        $t(`법인등록번호`)
                                    }}</p>
                                <div>
                                    <h6 class="gray-700 text-black fw-500 f-110 mb-0">
                                        {{
                                            selected_vendor.company.corporate_code || '-'
                                        }}</h6>
                                </div>
                            </b-td>
                            <b-td>
                                <p class="f-90 gray-600 fw-400 mb-1">{{
                                        $t(`사업자등록번호`)
                                    }}</p>
                                <div>
                                    <h6 class="gray-700 text-black fw-500 f-110 mb-0">
                                        {{
                                            selected_vendor.company.company_code || '-'
                                        }}</h6>
                                </div>
                            </b-td>
                            <b-td>
                                <p class="f-90 gray-600 fw-400 mb-1">
                                    {{ $t(`DUNS Number`) }}</p>
                                <div>
                                    <h6 class="gray-700 text-black fw-500 f-110 mb-0">
                                        {{ selected_vendor.company.duns_number || '-' }}</h6>
                                </div>
                            </b-td>
                        </b-tr>
                    </template>
                </b-tbody>
            </b-table-simple>
            <!--      lg 보다 작은 화면의 경우          -->
            <b-list-group no-gutters class="d-block d-lg-none">
                <b-list-group-item>
                    <p class="f-90 gray-600 fw-400 mb-1">{{ $t(`기업명 및 소재지`) }}</p>
                    <div>
                        <h6 v-show="$i18n.locale === 'ko'"
                            class="gray-700 text-black fw-500 f-110 mb-0">
                            {{ selected_vendor.company.company_name_dip }} /
                            {{ selected_vendor.company.country }}</h6>
                        <h6 v-show="$i18n.locale !== 'ko'"
                            class="gray-700 text-black fw-500 f-110 mb-0">
                            {{ selected_vendor.company.company_name_en_dip }} /
                            {{ selected_vendor.company.country_en }}</h6>
                    </div>
                </b-list-group-item>
                <b-list-group-item v-if="tenant_register">
                    <p class="f-90 gray-600 fw-400 mb-1">
                        {{ $t(`원청사`) }}
                    </p>
                    <div>
                        <h6 class="gray-700 text-black fw-500 f-110 mb-0">
                            {{ selected_vendor.hd_corporate || '-' }}
                        </h6>
                    </div>
                </b-list-group-item>
                <b-list-group-item>
                    <p class="f-90 gray-600 fw-400 mb-1">{{ $t(`업체코드`) }}</p>
                    <div>
                        <h6 class="gray-700 text-black fw-500 f-110 mb-0">
                            {{ selected_vendor.vendor_code }}</h6>
                    </div>
                </b-list-group-item>
                <b-list-group-item>
                    <p class="f-90 gray-600 fw-400 mb-1">{{ $t(`법인등록번호`) }}</p>
                    <div>
                        <h6 class="gray-700 text-black fw-500 f-110 mb-0">
                            {{ selected_vendor.company.corporate_code || '-' }}</h6>
                    </div>
                </b-list-group-item>
                <b-list-group-item>
                    <p class="f-90 gray-600 fw-400 mb-1">{{ $t(`사업자등록번호`) }}</p>
                    <div>
                        <h6 class="gray-700 text-black fw-500 f-110 mb-0">
                            {{ selected_vendor.company.company_code || '-' }}</h6>
                    </div>
                </b-list-group-item>
                <b-list-group-item>
                    <p class="f-90 gray-600 fw-400 mb-1">{{ $t(`DUNS Number`) }}</p>
                    <div>
                        <h6 class="gray-700 text-black fw-500 f-110 mb-0">
                            {{ selected_vendor.company.duns_number || '-' }}</h6>
                    </div>
                </b-list-group-item>
            </b-list-group>
        </div>


        <div class="fw-500 pb-1" autofocus>
            <span v-if="phase_step === 2">*</span> {{ $t(`이메일 (로그인 ID)`) }}
        </div>

        <b-form-input id="register-user-email"
                      v-model.trim="form.e_mail"
                      :disabled="phase_step !== 1 || calcLoading"
                      placeholder="ex. email@email.com"
                      autocomplete="new-password"
                      @keypress.enter="handleNext"
        >
        </b-form-input>

        <template v-if="phase_step === 2 && !is_user_duplicated">
            <div class="pt-3 pb-1">* {{ $t(`성함`) }}</div>
            <b-form-input v-model.trim="form.user_name" :placeholder="$t(`성함`)"
                          :disabled="calcLoading"
            />

            <div class="pt-3 pb-1">* {{ $t(`비밀번호`) }}</div>
            <b-form-input v-model.trim="form.password" :placeholder="$t(`4자리 이상`)"
                          type="password"
                          autocomplete="new-password"
                          :disabled="calcLoading"
            />

            <div class="pt-3 pb-1">* {{ $t(`비밀번호 확인`) }}</div>
            <b-form-input
                v-model.trim="form.password_2"
                type="password"
                :placeholder="$t(`비밀번호 한번 더 입력`)"
                aria-describedby="password_check_feedback"
                autocomplete="new-password"
                :disabled="calcLoading"
                :state="!form.password || !form.password_2 ? null : form.password === form.password_2"
            />
            <b-form-invalid-feedback id="password_check_feedback">
                {{ $t(`비밀번호를 동일하게 입력해 주세요`) }}
            </b-form-invalid-feedback>

            <div class="d-flex">
                <div class="w-25 mr-3">
                    <div class="pt-3 pb-1">* {{ $t(`국가 코드`) }}</div>
                    <b-form-select id="input-company_country"
                                   v-model="form.national_code"
                                   :options="nation_codes"
                                   :text-field="$i18n.locale ===  'ko' ? 'text' : 'text_en'"
                                   value-field="value"
                                   :disabled="calcLoading"
                                   autocomplete="new-password"
                    >
                    </b-form-select>
                </div>

                <div class="w-75">
                    <div class="pt-3 pb-1">* {{ $t(`연락처`) }}</div>
                    <b-form-input v-model.trim="form.tel_office"
                                  aria-describedby="national-code-help-block"
                                  :placeholder="form.national_code === null ? `(+${($t('국가 코드'))}) 000-0000-0000` : '000-0000-0000'"
                                  :disabled="calcLoading"
                                  autocomplete="new-password"
                    />
                </div>
            </div>
        </template>
        <template v-if="phase_step === 2">
            <template v-if="!selected_vendor.validated">
                <div class="pt-3 pb-1">* {{ $t(`사업자등록번호`) }}</div>
                <!-- 회사에 이미 번호가 있으면 보여주기만 한다. 서버도 다른 값으로 바꾸는 요청은 거부한다 -->
                <b-form-input
                    v-if="existing_company_code"
                    :value="existing_company_code"
                    disabled
                />
                <b-form-input
                    v-else
                    v-model.trim="form.company_code"
                    :placeholder="$t(`사업자등록번호`)"
                    autocomplete="new-password"
                />
            </template>

            <template v-if="!has_service_request">
                <div class="pt-3 pb-1">* {{ $t(`결과보고서 희망 언어`) }}</div>
                <b-form-select v-model="form.report_lang"
                               :options="report_lang_options"
                               :disabled="calcLoading"
                               @change="report_lang_touched = true"
                />
            </template>

            <template v-if="input_keys?.length > 0">
                <ProjectInputForm v-model="form" :input_keys="input_keys"
                                  :loading="calcLoading"
                />
            </template>
            
        </template>
        <template v-else-if="phase_step === 3 && is_user_duplicated">
            <div class="mt-3">
                <h5>{{ $t('이미 회원가입 하신 사용자이므로 3초후 평가신청 단계로 진행됩니다.') }}</h5>
            </div>
        </template>


        <InputConfirmModal :input_keys="input_keys"
                           :form="form"
                           @confirm="confirmSelection"
                           @cancel="cancelSelection"
        />

        <!-- 동의는 모달의 [확인] 으로만 성립한다 (체크만 하고 창을 닫은 것은 동의가 아님) -->
        <PrivacyAgree :privacy_agree="privacy_agree"
                      @goNext="agreedPrivacy"
        />

        <CommonRegisterFooter>
            <b-btn variant="blue"
                   :disabled="!selected_vendor || calcLoading"
                   @click="handleNext"
            >
                <b-spinner v-if="calcLoading" small class="mr-1"/>
                {{ $t(`다음`) }}
            </b-btn>
        </CommonRegisterFooter>
    </div>
</template>

<script>
import dayjs from 'dayjs';
import CommonRegisterFooter from '@/components/auth/Register/_SubComponents/CommonRegisterFooter.vue';
import {mapActions, mapState} from 'vuex';
import * as Sentry from '@sentry/vue';
import PrivacyAgree from '@/components/auth/Register/_SubComponents/RegisterStep2/PrivacyAgree.vue';
import InputConfirmModal from '@/components/auth/Register/_SubComponents/RegisterStep2/InputConfirmModal.vue';
import {inputKeyDescriptionHtml} from '@/components/auth/Register/_SubComponents/RegisterStep2/inputKeyDescription';
import {REGISTER_INQUIRY_MODAL_ID} from '@/components/auth/Register/_SubComponents/RegisterInquiryModal.vue';
import {tenant, mergeTenantRegister} from '@shared/utils/tenant';
import {nation_codes} from '@/components/auth/Register/_SubComponents/data';
import ProjectInputForm from '@/components/auth/Register/_SubComponents/RegisterStep2/ProjectInputForm.vue';
import {waitTime} from '@shared/utils/common';
import {localize} from 'vee-validate';

/**
 * Step 2 — 신청자 확인 → 정보 입력 → 신청.
 *
 * phase_step
 *   1: 이메일 입력 (가입 여부·중복 신청 확인 전)
 *   2: 정보 입력 (신규 가입자는 회원 정보까지, 기가입자는 신청 정보만)
 *   3: 기가입자 자동 진행 안내 ("3초 후 진행") — 신청 중에만 잠깐 보인다
 *
 * 서버 요청은 handleNext() 한 곳에서만 시작하고, 그동안 store.register_loading 으로
 * 모든 버튼·뒤로가기·로고를 막는다. 실패하면 이 화면에 머문 채(입력 유지) 에러 모달 하나만 띄운다.
 */
export default {
    name: 'RegisterStep2',
    components: {InputConfirmModal, ProjectInputForm, PrivacyAgree, CommonRegisterFooter},
    data() {
        return {
            form: {
                e_mail: '',
                user_name: '',
                password: '',
                password_2: '',
                tel_office: '',
                national_code: null,
                company_code: null,
                // 결과보고서 희망 언어 — 직접 고르기 전까지 화면 언어를 따라간다
                report_lang: this.$i18n.locale,
            },
            report_lang_touched: false,
            // 이 회사·프로젝트의 신청(df_nice_service_request)이 이미 있으면 true.
            // 결과보고서 희망 언어는 신청을 처음 만드는 사람만 고른다.
            has_service_request: false,
            input_keys: null,
            is_user_duplicated: false,
            // 개인정보 동의. 한 번 동의하면 실패 후 다시 신청할 때 다시 묻지 않는다.
            privacy_agree: false,
            // 캠페인 결정 항목(기업 규모 등) 재확인 완료 여부 — 해당 값을 바꾸면 다시 확인
            selectionConfirmed: false,
            campaign_id: null,
            // 신청이 반드시 실패하는 상태(프로젝트 설정 미완료 / 신청 준비 정보 조회 실패)면 진행을 막는다.
            // 개인정보를 받기 전에 막는 게 목적이다.
            blocked_message: null,
            phase_step: 1,
        };
    },
    computed: {
        ...mapState('register', ['register_loading', 'selected_vendor', 'remote_register_config']),
        tenant_register() {
            return mergeTenantRegister(tenant && tenant.register, this.remote_register_config);
        },
        // 재확인 게이트 — confirmGate 테넌트(steel)에서 기준 설명 있는 input_key 가 있을 때만
        hasCriteriaInputs() {
            if (!this.tenant_register || !this.tenant_register.confirmGate) return false;
            const locale = this.$i18n.locale;
            return (this.input_keys || []).some(item => !!inputKeyDescriptionHtml(item, locale));
        },
        // 재확인 대상 값 — 바뀌면 재확인을 다시 받는다
        criteriaSnapshot() {
            return JSON.stringify((this.input_keys || []).map(item => this.form[item.key_name]));
        },
        nation_codes() {
            return nation_codes;
        },
        calcLoading() {
            return this.register_loading;
        },
        existing_company_code() {
            return this.selected_vendor?.company?.company_code?.trim() || null;
        },
        // 첫 신청(미검증 벤더)인데 회사에 사업자번호가 없을 때만 입력받는다
        company_code_input_needed() {
            return !this.selected_vendor.validated && !this.existing_company_code;
        },
        report_lang_options() {
            return [
                {text: '한국어', value: 'ko'},
                {text: 'English', value: 'en'},
                {text: '中文', value: 'ca'},
            ];
        },
    },
    watch: {
        '$i18n.locale'(locale) {
            if (!this.report_lang_touched) this.form.report_lang = locale;
        },
        criteriaSnapshot() {
            this.selectionConfirmed = false;
        },
    },
    created() {
        if (this.selected_vendor?.company?.country) {
            this.form.national_code = this.nation_codes.find(item => {
                return item.text.includes(this.selected_vendor.company.country);
            })?.value || null;
        }
        this.runExclusive(() => this.loadRequestPrerequisites());
    },
    methods: {
        ...mapActions('register', ['setRegisterLoading', 'setDuplicated', 'completeRequest']),

        // 서버 요청이 겹치지 않게 한 번에 하나만 실행한다. 이미 진행 중이면 무시.
        async runExclusive(task) {
            if (this.register_loading) return;
            this.setRegisterLoading(true);
            try {
                await task();
            } catch (error) {
                await this.handleError(error);
            } finally {
                this.setRegisterLoading(false);
            }
        },

        // 신청 준비: 이미 캠페인이 정해진 회사인지, 아니면 캠페인 판별 입력이 필요한지
        async loadRequestPrerequisites() {
            try {
                const assigned = await this.$axios.get('/register/company_project', {
                    params: {
                        project_id: this.selected_vendor.project,
                        company_id: this.selected_vendor.company.id,
                    },
                });
                if (assigned.status === 200) {
                    this.campaign_id = assigned.data.id;
                    this.has_service_request = true;
                    this.input_keys = null;   // 이미 정해진 캠페인으로 신청 — 판별 입력 불필요
                    return;
                }

                const {data} = await this.$axios.get(`/project-schema/projects/${this.selected_vendor.project}/schema`);

                // 백엔드가 "지금 이 프로젝트로 신청이 가능한가" 를 신청 API 와 같은 기준으로 계산해 준다.
                // 불가능하면 개인정보를 받기 전에 막는다 (prod 2026-07-23: 판별 불가인데 진행 → 422).
                if (data.campaign_resolution && !data.campaign_resolution.ready) {
                    this.block(this.$t('프로젝트 설정이 완료되지 않아 현재 평가를 신청할 수 없습니다. QESG로 문의해주세요.'));
                    return;
                }

                data.input_keys.forEach(item => {
                    if (item.value_type === 'list') {
                        item.allowed_values = item.allowed_values.map(value => ({
                            ...value,
                            label_ko: value.label_texts.ko,
                            label_en: value.label_texts.en,
                            label_ca: value.label_texts.ca,
                        }));
                    }
                    this.$set(this.form, item.key_name, null);
                });
                this.input_keys = data.input_keys;
            } catch (e) {
                // 판별 정보 없이 진행하면 개인정보를 다 받은 뒤 신청이 실패하므로 막는다
                this.block(this.$t('평가 신청에 필요한 정보를 받아오는데 실패했습니다. 다시 시도해주시거나 에러가 지속적으로 발생 시, QESG로 문의해주세요.'));
            }
        },
        block(message) {
            this.blocked_message = message;
            this.showError(message);
        },

        // 모달에서 [확인] → 동의 성립 후 이어서 진행
        agreedPrivacy() {
            this.privacy_agree = true;
            this.$bvModal.hide('register-privacy-agree');
            this.handleNext();
        },
        // 재확인 모달: [확인하고 계속] → 이어서 진행 / [다시 선택] → 모달만 닫힘
        confirmSelection() {
            this.selectionConfirmed = true;
            this.$bvModal.hide('register-input-confirm');
            this.handleNext();
        },
        cancelSelection() {
            this.selectionConfirmed = false;
        },

        handleNext() {
            if (this.blocked_message) {
                this.showError(this.blocked_message);
                return;
            }
            return this.runExclusive(() => (this.phase_step === 1 ? this.checkApplicant() : this.proceed()));
        },

        // Phase 1: 이메일로 가입 여부·중복 신청 확인
        async checkApplicant() {
            const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            if (this.isFieldEmpty(this.form.e_mail) || !emailRegex.test(this.form.e_mail)) {
                alert(this.$t('이메일을 정확히 입력하여 주십시오.'));
                return;
            }

            const {data} = await this.$axios.get('/register/verification_user_project', {
                params: {
                    email: this.form.e_mail,
                    vendor_code: this.selected_vendor?.vendor_code,
                    project_code: this.selected_vendor?.project_code,
                },
            });

            this.is_user_duplicated = !!data.user;
            this.phase_step = 2;

            // 기가입자는 회원정보·동의 없이, 캠페인이 이미 정해졌으면 바로 신청까지 진행
            if (this.is_user_duplicated) {
                this.privacy_agree = true;
                if (this.campaign_id != null) await this.proceed();
            }
        },

        // Phase 2: 입력 검증 → (재확인) → (동의) → 신청
        async proceed() {
            if (!this.is_user_duplicated && !this.formValidationCheck()) return;
            if (this.company_code_input_needed && !this.validateCompanyCode()) return;
            if (this.input_keys?.length > 0 && !this.projectKeyValidationCheck()) return;

            if (this.hasCriteriaInputs && !this.selectionConfirmed) {
                this.$bvModal.show('register-input-confirm');
                return;
            }
            if (!this.privacy_agree) {
                this.$bvModal.show('register-privacy-agree');
                return;
            }

            if (this.is_user_duplicated) {
                // "이미 회원가입 하신 사용자이므로 3초후 평가신청 단계로 진행됩니다." 안내를 보여준 뒤 진행
                this.phase_step = 3;
                await waitTime(2500);
            }
            try {
                await this.submit();
            } finally {
                // 실패해도 입력 화면으로 돌아와 그대로 다시 신청할 수 있게 한다
                this.phase_step = 2;
            }
        },

        async submit() {
            let campaign_id = this.campaign_id;
            const project_input_form = {};
            (this.input_keys || []).forEach(item => {
                project_input_form[item.key_name] = this.form[item.key_name];
            });
            if (campaign_id == null && Object.keys(project_input_form).length > 0) {
                const {data} = await this.$axios.post('/rule-engine/evaluate/match-campaign', {
                    project_id: this.selected_vendor?.project,
                    user_inputs: project_input_form,
                });
                campaign_id = data?.campaign_id;
            }

            const vendor = this.selected_vendor;
            const body = {
                project_code: vendor?.project_code,
                campaign_id,
                company_id: vendor?.company?.id,
                // company_code 는 '저장할 번호' — 새로 입력한 경우만 보낸다 (저장할 수 없는 번호면 서버가 422)
                company_code: this.company_code_input_needed ? this.form.company_code : undefined,
                vendor_code: vendor?.vendor_code,
                email: this.form.e_mail,
                lang: this.$i18n.locale,
                report_lang: this.has_service_request ? undefined : this.form.report_lang,
            };
            if (!this.is_user_duplicated) {
                body.user_name = this.form.user_name;
                body.password = this.form.password;
                body.tel_office = !this.form.national_code
                    ? this.form.tel_office
                    : `(${this.form.national_code}) ${this.form.tel_office}`;
            }

            const {data} = await this.$axios.post('/register/request', body);

            this.breadcrumb('Info');
            this.$EventBus.$emit('toast-success', this.$t('회원가입 완료'), this.$t('QESG 평가신청이 완료되었습니다'));
            this.completeRequest(data);
        },

        handleError(error) {
            const {status, data} = error?.response || {};
            this.breadcrumb('Error', data?.message || error?.message);

            // 이 이메일로 이미 이 프로젝트에 신청돼 있음 → 중복 신청 안내 화면
            // 서버는 상태(access_status·role·create_date)만 준다 — 회사명·이메일은 화면이 아는 값
            if (status === 409 && data?.message === 'Duplicated_Project_Request') {
                const request = {
                    ...data.request,
                    create_date: dayjs(data.request?.create_date).format('YYYY년 M월 D일 HH:mm:ss'),
                    company_name: this.selected_vendor?.company?.company_name,
                    email: this.form.e_mail,
                };
                this.setDuplicated({message: request, email: this.form.e_mail});
                return;
            }

            // 같은 회사의 다른 담당자가 먼저 신청함(업체는 프로젝트에 한 번만 참여) → 그 신청으로 다시 신청
            if (status === 409 && data?.message === 'Project_Already_Requested') {
                this.showError(this.$t('같은 회사의 다른 담당자가 이 프로젝트에 먼저 신청했습니다. [다음] 버튼을 다시 누르면 기존 신청에 함께 등록됩니다.'));
                return this.loadRequestPrerequisites();
            }

            // 취소된 신청도 '신청 있음' — 다시 신청할 수 없고 QESG 확인이 필요하다
            if (status === 409 && data?.message === 'Project_Request_Canceled') {
                this.block(this.$t('이 회사의 이 프로젝트 신청은 취소된 상태입니다. QESG로 문의해주세요.'));
                return;
            }

            // 메일 발송 실패 = 신청 미완료(서버가 롤백). 잠시 후 그대로 다시 신청하면 된다.
            if (data?.code === 'email_failure') {
                this.showError(this.$t('이메일 전송에 실패하여 평가 신청이 완료되지 않았습니다. 잠시 후 다시 신청해주세요.'));
                return;
            }
            this.showError(this.$t('평가 신청에 실패했습니다. 잠시 후 다시 시도해주시거나, 문제가 계속되면 QESG로 문의해주세요.'));
        },
        // 실패 안내는 이 모달 하나. [문의하기] 를 누르면 문의 창을 연다.
        async showError(message) {
            const inquire = await this.$showModal({
                type: 'confirm',
                state: 'error',
                title: this.$t('평가 신청 오류'),
                message,
                modalOptions: {okTitle: this.$t('문의하기'), cancelTitle: this.$t('닫기')},
            });
            if (inquire) this.$bvModal.show(REGISTER_INQUIRY_MODAL_ID);
        },
        breadcrumb(level, message) {
            Sentry.addBreadcrumb({
                level,
                type: 'Auth',
                category: 'Register',
                data: {
                    email: this.form.e_mail,
                    vendor_code: this.selected_vendor?.vendor_code,
                    company_name: this.selected_vendor?.company?.company_name,
                    message,
                },
            });
        },

        formValidationCheck() {
            if (!this.form.e_mail || !this.form.user_name || !this.form.password || !this.form.tel_office) {
                alert(this.$t('회원가입에 필요한 필수정보를 입력해주세요.'));
                return false;
            }
            if (this.form.password !== this.form.password_2) {
                alert(this.$t('비밀번호 확인을 위해 정확히 기재해주세요.'));
                return false;
            }
            return true;
        },
        projectKeyValidationCheck() {
            const missing = this.input_keys.find(item =>
                item.is_required && (this.form[item.key_name] === null || this.form[item.key_name] === ''));
            if (missing) {
                alert(this.$t(`필수 입력 항목인 ${missing.label_texts?.[this.$i18n.locale] || missing.label_texts?.ko}을(를) 입력해주세요.`));
                return false;
            }
            return true;
        },
        // 한국 사업자등록번호 체크섬
        isKrBusinessNumber(number) {
            const digits = number.replace(/-/g, '').split('').map(d => parseInt(d, 10));
            if (digits.length !== 10) return false;
            const keys = [1, 3, 7, 1, 3, 7, 1, 3, 5];
            let sum = keys.reduce((acc, k, i) => acc + k * digits[i], 0);
            sum += Math.floor((keys[8] * digits[8]) / 10);
            return digits[9] === (10 - (sum % 10)) % 10;
        },
        validateCompanyCode() {
            if (this.isFieldEmpty(this.form.company_code)) {
                alert(this.$t('사업자 코드를 입력해주세요.'));
                return false;
            }
            // 한국어 화면에서만 한국 사업자번호로 검사한다. 해외 기업일 수 있으니 막지 않고 영어 전환을 권한다.
            if (this.$i18n.locale === 'ko' && !this.isKrBusinessNumber(this.form.company_code.trim())) {
                this.showOverseasBusinessNumberModal();
                return false;
            }
            return true;
        },
        // 한국어 UI 에서 한국 사업자등록번호 체크섬에 실패한 경우:
        // 해외(대한민국 외) 등록 기업일 수 있으므로, alert 로 막지 않고
        // 언어를 English 로 전환하도록 유도한다. 전환해도 입력값은 유지된다
        // (locale 반응형 대입 + localize 만 수행, 리로드/재마운트 없음).
        showOverseasBusinessNumberModal() {
            const h = this.$createElement;
            const message = h('div', [
                h('p', {class: 'mb-2'}, '입력하신 번호는 대한민국 사업자등록번호로 확인되지 않습니다. 대한민국 외 국가에 등록된 기업이라면 화면 언어를 English 로 변경한 뒤 다시 신청해 주세요. 입력하신 정보는 그대로 유지됩니다.'),
                h('p', {class: 'mb-0 text-secondary'}, 'This number is not recognized as a Korean business registration number. If your company is registered outside Korea, switch the language to English and continue. Your entered information will be kept.'),
            ]);
            this.$showModal({
                type: 'confirm',
                state: 'warning',
                title: '사업자등록번호 확인 / Business Registration Number',
                message,
                modalOptions: {
                    okTitle: 'English 로 전환 / Switch to English',
                    cancelTitle: '닫기 / Close',
                },
            }).then((confirmed) => {
                if (confirmed) {
                    this.$i18n.locale = 'en';
                    localize('en');
                }
            });
        },
    },
};
</script>

<style lang="scss" scoped>

</style>
